// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const haunter: PokeData = {
  "id": 93,
  "name": "haunter",
  "height": 16,
  "weight": 1,
  "base_experience": 142,
  "types": [
    PokeType.GHOST,
    PokeType.POISON
  ],
  "api_moves": [
    "toxic",
    "hypnosis",
    "night-shade",
    "confuse-ray",
    "lick",
    "smog",
    "dream-eater",
    "poison-gas",
    "nightmare",
    "curse",
    "spite",
    "destiny-bond",
    "mean-look",
    "shadow-ball",
    "will-o-wisp",
    "astonish",
    "shadow-punch",
    "payback",
    "sucker-punch",
    "dark-pulse",
    "venoshock",
    "hex"
  ],
  "moves": [
    "night-shade",
    "confuse-ray",
    "lick",
    "poison-gas",
    "curse",
    "shadow-ball",
    "dark-pulse",
    "shadow-sneak",
    "poltergeist",
    "mortal-gas",
    "soul-sacrifice",
    "spectral-chain",
    "shadow-claws"
  ],
  "evolution_chain": {
    "id": 40,
    "item": null,
    "species": [
      {
        "name": "gastly",
        "order": 100,
        "types": [
          PokeType.GHOST,
          PokeType.POISON
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "haunter",
        "order": 101,
        "types": [
          PokeType.GHOST,
          PokeType.POISON
        ],
        "evolves_from_species_id": 92,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 25,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "gengar",
        "order": 102,
        "types": [
          PokeType.GHOST,
          PokeType.POISON
        ],
        "evolves_from_species_id": 93,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.TRADE
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 47.5,
    "speed": 95,
    "ability_power": 115
  },
  "stat_changes": [],
  "catch_rate": 90,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
